import React, { useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import { AuthenticationService } from '../../services/authentication.service';
import DescargaService from '../../services/descarga.service';
import * as Constants from '../../constants';

const Descarga = () => {
  const { t } = useTranslation("global");
  
  const authenticationService = new AuthenticationService();
  const navigate = useNavigate();
  
  useEffect(() => {
	const authentication = authenticationService.getAuthenticationSession();
			
	if(authentication === null) {
		navigate(Constants.ROUTE_ROOT);
	} else {
		handleDownload();
	}
  }, [navigate]);
  
  const handleDownload  = async () => {	
	await DescargaService.getDescargaFichero()
	.then(response => response.blob())
	.then(blob => {
		const url = window.URL.createObjectURL(blob);
		const a = document.createElement('a');
        a.href = url;
        a.download = 'levitup-app.apk'; // Nombre con el que se descargará el archivo
        document.body.appendChild(a);
        a.click();
        a.remove();
	});
  }

  return (
    <div>
      <h2>{t("app.descarga.mensaje")}</h2>
    </div>
  );
};

export default Descarga;
